require('./lbTimeoutModal.scss');

const lbTimeoutModal = angular.module('app.lbTimeoutModal', []);

lbTimeoutModal.component('lbTimeoutModal', {
  controller: ['lbModalService', 'Idle', lbTimeoutModalCtrl],
  controllerAs: 'vm',
  template: require('./lbTimeoutModal.html'),
});

function lbTimeoutModalCtrl(lbModalService, Idle) {
  let vm = this;

  vm.timeoutValue = Idle.getTimeout();

  vm.close = close;
  vm.getCountdownNoun = getCountdownNoun;

  function getCountdownNoun(countdown) {
    return countdown === 1 ? 'second' : 'seconds';
  }

  function close() {
    lbModalService.resolve();
    Idle.watch();
  }
}

export default lbTimeoutModal;



// WEBPACK FOOTER //
// ./src/components/lbTimeoutModal/lbTimeoutModal.js